import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


export interface AppearanceOptions {
  theme: string;
  dir: string;
  layout: string;
  sidebartype: string;
  sidebarpos: string;
  headerpos: string;
  boxed: string;
  navbarbg: string;
  sidebarbg: string;
  logobg: string;
}



@Injectable({
  providedIn: 'root'
})
export class AppearanceSettings {
  private initialOptions: AppearanceOptions = {
    theme: 'light', // two possible values: light, dark
    dir: 'ltr', // two possible values: ltr, rtl
    layout: 'vertical', // fixed value. shouldn't be changed.
    sidebartype: 'mini-sidebar', // four possible values: full, iconbar, overlay, mini-sidebar
    sidebarpos: 'fixed', // two possible values: fixed, absolute
    headerpos: 'fixed', // two possible values: fixed, absolute
    boxed: 'full', // two possible values: full, boxed
    navbarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    sidebarbg: 'skin5', // six possible values: skin(1/2/3/4/5/6)
    logobg: 'skin5' // six possible values: skin(1/2/3/4/5/6)
}

  private optionsSource = new BehaviorSubject<AppearanceOptions>(this.initialOptions);
  options$ = this.optionsSource.asObservable();

  updateOptions(newOptions: Partial<AppearanceOptions>) {
    this.optionsSource.next({ ...this.optionsSource.value, ...newOptions });
  }
}

